import React, {Fragment} from 'react';
import { ApolloProvider } from '@apollo/react-hooks';
import ls from 'local-storage';

/*import SimpleBoomer from './SimpleBoomer';*/

import { getClient } from '@squirrellearningltd/go-shared-utils';
import { APP_NAME } from '../../../services/constants';
const Confirm = ({ 
    cancelMessage, 
    children, 
    className,
    confirmMessage, 
    emojiWarning,
    message, 
    onClose, 
    onConfirm, 
    title, 
    variables 
}) => (
    <ApolloProvider client={getClient(APP_NAME)}>
        <div 
            onClick={(event) => {
                if (event.target.classList.contains('confirm-overlay')) {
                    onClose();
                }
            }} 
            className={`confirm-overlay ${className}`}
        >
            <div className="confirm-overlay__body">
                {/*
                    ls('token') ? (
                        <div className="confirm-overlay__boomer">
                            <SimpleBoomer mutation="in-confirm" />
                        </div>
                    ) : null
                    */}
                
                <button onClick={onClose} className="confirm-overlay__close-button">
                    <span className="confirm-overlay__close-icon">x</span>
                </button>
                {title && <p className="confirm-overlay__title">{title}</p>}
                {children}
                <div className="confirm-overlay__buttons">
                    <button 
                        className="button button--bordered confirm-overlay__button" 
                        onClick={() => {
                            onConfirm({ variables }); 
                            onClose();
                        }}
                    >
                        {confirmMessage || 'Yes'}
                    </button>
                    <button className="button button--bordered button--red confirm-overlay__button" onClick={onClose}>{cancelMessage || 'No'}</button>
                </div>
            </div>
        </div>
    </ApolloProvider>
);

export default Confirm;
